// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_chat_instruction_text = /** @type {(inputs: {}) => string} */ () => {
	return `Ask me any questions about Japanese language or learning strategies!`
};

const id_chat_instruction_text = /** @type {(inputs: {}) => string} */ () => {
	return `Tanyakan saya pertanyaan apa pun tentang bahasa Jepang atau strategi belajar!`
};

const ja_chat_instruction_text = /** @type {(inputs: {}) => string} */ () => {
	return `日本語や学習戦略についてご質問があれば何でもお尋ねください。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_instruction_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_instruction_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_instruction_text", locale)
	if (locale === "en") return en_chat_instruction_text(inputs)
	if (locale === "id") return id_chat_instruction_text(inputs)
	return ja_chat_instruction_text(inputs)
};
export { chat_instruction_text as "chat.instruction_text" }